import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import Api from "../../../../../Services/Api";
import {getValueFromDDL} from "../../../../common/mapper";
import ReceivingUnitDGIInputs from "./receivingUnitDGIInputs";
import dayjs from "dayjs";
import {HttpStatus} from "../../../../common/Constants";
import {
    contructQueryParam,
    fetchDataAsync,
} from "../../../../../Services/Utils";
import { constructGenSeqPayload } from "../util";

class ReceivingUnitDGIProcess extends Component {
    tableColumns = [
        {
            name: "",
            label: "#",
            options: {
                customBodyRender: (_, {rowIndex}) => <>{rowIndex + 1}</>,
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "kodeVarian",
            label: "Kode Varian",
            options: {
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
                sort: false,
            },
        },
        {
            name: "namaVarian",
            label: "Nama Varian",
            options: {
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
                sort: false,
            },
        },
        {
            name: "frameNumber",
            label: "No. Ka",
            options: {
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
                sort: false,
            },
        },
        {
            name: "engineNumber",
            label: "No. Sin",
            options: {
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
                sort: false,
            },
        },
        {
            name: "kodeWarna",
            label: "Kode Warna",
            options: {
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
                sort: false,
            },
        },
        {
            name: "namaWarnaPabrik",
            label: "Nama Warna",
            options: {
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
                sort: false,
            },
        },
        {
            name: "statusRfs",
            label: "RFS",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    const isEditable = this.state.data.listUnitDetail[rowIndex].editable;
                    return (
                        <input
                            id="input_checkbox_rfs"
                            name="statusRfs"
                            type="checkbox"
                            disabled={!isEditable}
                            checked={val === "RFS"}
                            onChange={({target}) =>
                                this.handleUpdateTableData(
                                    rowIndex,
                                    target.name,
                                    val === "RFS" ? "NRFS" : "RFS"
                                )
                            }
                        />
                    );
                },
                sort: false,
            },
        },
        {
            name: "yearManufactured",
            label: "Thn. Prod",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    const isEditable = this.state.data.listUnitDetail[rowIndex].editable;
                    return (
                        <SimpleInput
                            id="input_text_tahun_produksi"
                            box="onlyNumber"
                            name="yearManufactured"
                            containerclassname="margin-bottom-none"
                            maxLength={4}
                            value={val}
                            readOnly={!isEditable}
                            onChange={({target}) =>
                                this.handleUpdateTableData(rowIndex, target.name, target.value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "70px"},
                }),
                sort: false,
            },
        },
        {
            name: "kodeLocation",
            options: {
                customHeadRender: (props) => {
                    return (
                        <th key={props.index} className="custom-locator padding-right-15px">
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <p>
                                    [<span style={{color: "red"}}>*</span>] All Locator
                                </p>
                                <SimpleDDL
                                    id="select_options_header_locator"
                                    containerclassname="margin-bottom-none width width-250px"
                                    box="search"
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            position: "relative",
                                            fontFamily:
                                                "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                        }),
                                    }}
                                    options={this.state.locatorOptions}
                                    onChange={this.handleMultipleLocatorChange}
                                />
                            </FlexView>
                        </th>
                    );
                },
                customBodyRender: (val, {rowIndex}) => {
                    const isEditable = this.state.data.listUnitDetail[rowIndex].editable;
                    let defaultValue;
                    if (typeof val === "string") {
                        defaultValue = this.state.locatorOptions.find(
                            (l) => l.value === val
                        );
                    } else {
                        defaultValue = val;
                    }

                    return (
                        <>
                            <SimpleDDL
                                id={`select_options_locator_${rowIndex}`}
                                containerclassname="margin-bottom-none width width-250px"
                                name="kodeLocation"
                                box="search"
                                readOnly={!isEditable}
                                value={defaultValue}
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        position: "relative",
                                        fontFamily:
                                            "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                options={this.state.locatorOptions}
                                onChange={(value) => this.handleLocatorChange(value, rowIndex)}
                            />
                        </>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            alertInformation: null,
            locatorOptions: [],
            expedisiOptions: [],
            formData: {},
            data: props.data || {},
            placeholderSPBMNo: ""
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const responses = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA")
                    .getAllMasterLocationPagingByParam,
                menuName: "Receiving Unit - DGI",
                setError: this.props.setError,
                args: {
                    paramFilters: {
                        kodeCabang: this.props.data.kodeCabang,
                    },
                },
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
                menuName: "Receiving Unit - DGI",
                setError: this.props.setError,
                args: contructQueryParam({kodeCabang: this.props.data.kodeCabang}),
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterSupplierById,
                menuName: "Receiving Unit - DGI",
                setError: this.props.setError,
                args: this.props.data.kodeSupplier,
            }),
        ]);
        if (responses[0].ok && responses[0].data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                locatorOptions: responses[0].data.data.map((l) => ({
                    label: l.nameLocation,
                    value: l.kodeLocation,
                    kodeCabang: l.kodeCabang,
                })),
            }));
        }

        if (responses[1].ok && responses[1].data.status === HttpStatus.SUCCESS) {
            let kodeExpedisiValue = null;
            if (this.state.data.kodeSupplierExpedisi) {
                const expedisiDDLValue = responses[1].data.data.find(
                    (e) => this.state.data.kodeSupplierExpedisi === e.supplierCode
                );
                kodeExpedisiValue = {
                    label: expedisiDDLValue.supplierCode,
                    value: expedisiDDLValue.supplierCode,
                    name: expedisiDDLValue.supplierName,
                };
            }

            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    kodeSupplierExpedisi: kodeExpedisiValue,
                },
                expedisiOptions: responses[1].data.data.map((e) => ({
                    label: e.supplierCode,
                    value: e.supplierCode,
                    name: e.supplierName,
                })),
            }));
        }

        if (responses[2].ok && responses[2].data.status === HttpStatus.SUCCESS) {
            let supplier = responses[2].data.data;
            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    kodeSupplier: supplier.supplierCode,
                    namaSupplier: supplier.supplierName,
                },
            }));
        }
        const tempSpbmNo = await this.fetchDataGenerateSeq(
          constructGenSeqPayload({ value: this.props.data.kodeCabang })
        );
        this.setState((prevValue) => ({...prevValue, loading: false, placeholderSPBMNo: tempSpbmNo}));
    }

    fetchDataGenerateSeq = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(body);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleMultipleLocatorChange = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                listUnitDetail: prevValue.data.listUnitDetail.map((data) =>
                    data.editable
                        ? {
                            ...data,
                            kodeLocation: value,
                        }
                        : data
                ),
            },
        }));
    };

    handleLocatorChange = (value, index) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.data.listUnitDetail];
            newState[index] = {
                ...newState[index],
                kodeLocation: value,
            };
            return {
                ...prevValue,
                data: {
                    ...prevValue.data,
                    listUnitDetail: newState,
                },
            };
        });
    };

    handleUpdateTableData = (index, name, value) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.data.listUnitDetail];
            newState[index] = {
                ...newState[index],
                [name]: value,
            };
            return {
                ...prevValue,
                data: {
                    ...prevValue.data,
                    listUnitDetail: newState,
                },
            };
        });
    };

    handleSubmitProcess = async (e) => {
        e.preventDefault();
        const editableData = this.state.data.listUnitDetail.filter(
            (dt) => dt.editable
        );
        if (!R.isEmpty(editableData)) {
            const isValid = editableData.every(
                (dt) =>
                    (dt.kodeLocation && dt.kodeLocation !== "") ||
                    (dt.kodeCabang && dt.kodeCabang !== "")
            );
            if (!isValid) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    alertInformation: {
                        error: true,
                        content: (
                            <div>
                                <p>
                                    Ada field data yang perlu diisi atau tidak sesuai kriteria
                                    isian.
                                </p>
                                <br/>
                                <p>Mohon periksa kembali.</p>
                            </div>
                        ),
                    },
                }));
                return;
            }
        }

        this.setState((prevValue) => ({...prevValue, loading: true}));
        let {namaSupplier, ...rest} = this.state.data;
        const editableDataUnit = this.state.data.listUnitDetail?.filter(item => item.editable) || []
        const request = {
            ...rest,
            spbmNo: null,
            jumlah: editableDataUnit?.length,
            spbmDate: dayjs(new Date()).format("DD-MM-YYYY"),
            kodeSupplierExpedisi: getValueFromDDL(
                this.state.data,
                "kodeSupplierExpedisi"
            ),
            listUnitDetail: editableDataUnit?.map((dt) => ({
                frameNumber: dt.frameNumber || "",
                statusRfs: dt.statusRfs || "",
                kodeVarian: dt.kodeVarian || "",
                engineNumber: dt.engineNumber || "",
                kodeWarna: dt?.idWarna || null,
                yearManufactured: dt.yearManufactured
                    ? parseInt(dt.yearManufactured)
                    : "",
                kodeLocation: dt.kodeLocation?.value
                    ? dt.kodeLocation?.value
                    : dt.kodeLocation,
                kodeCabang: dt.kodeLocation?.kodeCabang
                    ? dt.kodeLocation?.kodeCabang
                    : dt.kodeCabangLocation,
            })),
        };

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").updateReceivingDGI,
            menuName: "Receiving Unit - DGI",
            setError: this.props.setError,
            args: request
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                alertInformation: {
                    error: false,
                    content: <p>Data telah disimpan.</p>,
                },
            }));
        }

        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleResetForm = () => {
        console.log(this.state.data);

        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                description: "",
                noPolisi: "",
                kodeSupplierExpedisi: null,
                listUnitDetail: prevValue.data.listUnitDetail.map((item) => ({
                    ...item,
                    kodeLocation: null,
                    yearManufactured: null,
                    statusRfs: "NRFS",
                })),
            },
        }));
    };

    handleAlertVisibility = (action) => {
        if (!this.state.alertInformation.error) {
            const act = action === 'complete' ? 'refresh' : null
            this.props.onCloseDetail(act);
        }
        this.setState((prevValue) => ({...prevValue, alertInformation: null}));
    };

    render() {
        console.log(this.state?.placeholderSPBMNo,'')
        return (
            <>
                <SimpleModal
                    title="Proses Terima Unit DGI"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <form onSubmit={this.handleSubmitProcess}>
                                <ReceivingUnitDGIInputs
                                    state={this.state}
                                    onSetState={this.handleStateChange}
                                />
                                <h3>UNIT MOTOR</h3>
                                <SimpleDataTable
                                    data={this.state.data.listUnitDetail || []}
                                    columns={this.tableColumns}
                                    rowsPerPage={5}
                                    options={{serverSide: false}}
                                />
                                <br/>
                                <FlexView hAlignContent="right">
                                    <SimpleButton
                                        type="button"
                                        secondary
                                        onClick={this.handleResetForm}
                                    >
                                        Clear
                                    </SimpleButton>
                                    <SimpleButton type="submit">Simpan</SimpleButton>
                                </FlexView>
                            </form>
                        </ModalContainer>
                    }
                />
                {this.state.alertInformation !== null && (
                    <SimpleAlert
                        visible={this.state.alertInformation !== null}
                        onClickClose={this.handleAlertVisibility}
                        content={
                            <div>
                                {this.state.alertInformation.content}
                                <SimpleButton
                                    className="margin-left-none margin-top-15px"
                                    onClick={()=>this.handleAlertVisibility('complete')}
                                >
                                    OK
                                </SimpleButton>
                            </div>
                        }
                    />
                )}
                {this.state.loading && (
                    <SimpleLoadingOverlay active={this.state.loading}/>
                )}
            </>
        );
    }
}

export default ReceivingUnitDGIProcess;
